import { makeStyles } from 'makeStyles';

export const useStyles = makeStyles()((theme) => ({
  root: {
    border: '1px solid #dadce0',
    height: 40,
    [theme.breakpoints.up('sm')]: {
      minWidth: 300,
    },
    textDecoration: 'none',
    borderRadius: 3,
    '& button': {
      margin: 0,
    },
    '&:hover': {
      borderColor: '#9da1af',
    },
    '&.Mui-focused': {
      borderColor: '#418fde',
    },
  },
  input: {
    backgroundColor: theme.palette.background.paper,
    padding: `9px 0 8px 0`,
    position: 'relative',
    // transition: theme.transitions.create(['border-color', 'box-shadow']),
    textDecoration: 'none',
    fontSize: 15,
    fontWeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#3e424e',
    '&:focus': {
      borderRadius: 2,
      backgroundColor: theme.palette.background.paper,
    },
  },
  clearIcon: {
    '&:hover': {
      background: 'transparent',
    },
  },
  searchIcon: {
    padding: '0 8px 2px 4px',
    '&:hover': {
      background: 'transparent',
    },
  },
}));
